import posthog from 'posthog-js';
import type {
	PostHogEventMap,
	PostHogEvent,
	CaptureEvent,
	ExtendEventMap,
	NoProperties,
} from '@velocity-exchange/posthog-types';

/**
 * Typed posthog.capture for use outside React context.
 * Prefer usePostHogCapture hook inside React components/hooks.
 */
export function capturePostHogEvent<E extends PostHogEvent>(
	event: E,
	properties: PostHogEventMap[E]
): void {
	posthog.capture(event, properties);
}

// To add web-specific extensions or events, pass them to ExtendEventMap:
//   type WebEventMap = ExtendEventMap<
//     { collateral_deposit_submitted: { source?: string } },  // overrides
//     { web_only_event: { detail: string } }                  // new events
//   >;
export type WebEventMap = ExtendEventMap<
	NoProperties,
	{
		revenue_share_account_creation_error: { error: unknown };
		swap_and_deposit_submitted: {
			usdc_amount: number;
			usdt_min_out: number;
			new_account: boolean;
		};
		swap_and_deposit_completed: {
			swap_tx_sig: string;
			/** Rung of the slippage ladder the swap actually executed at. */
			slippage_bps: number;
		};
		swap_and_deposit_deposit_leg_failed: { swap_tx_sig: string };
	}
>;

export type WebCaptureEvent = CaptureEvent<WebEventMap>;

export type PosthogConfig = {
	enabled: boolean;
	consoleRecordingEnabled: boolean;
	sessionRecordingEnabled: boolean;
};

export const POSTHOG_CONFIG: PosthogConfig = {
	enabled: process.env.NEXT_PUBLIC_POSTHOG_ENABLED === 'true',
	consoleRecordingEnabled:
		process.env.NEXT_PUBLIC_POSTHOG_CONSOLE_RECORDING_ENABLED === 'true',
	sessionRecordingEnabled:
		process.env.NEXT_PUBLIC_POSTHOG_SESSION_RECORDING_ENABLED === 'true',
};
